import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        className: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const tooltip = tv({
            base: 'group relative',
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(tooltip)({
                    class: props.className,
                }))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
